"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// utils

/* ++++++++++ --------------- DISCARD BUTTON: DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'DiscardButton',
  group: _definitionhelpers.groupNames.ctas,
  props: {
    discardChanges: {
      type: 'function',
      default: function _default() {
        return console.log('discard changes');
      }
    },
    disabled: {
      type: 'boolean',
      default: false,
      options: [true, false]
    }
  }
};
exports.default = _default2;